<div class="popup-container">
  <div class="container-btClos-text" id="header">
    <div class="text-container">
      <span class="title-resume"> Resumen de operaciones diarias </span>
    </div>
    <mat-icon class="close-icon" [mat-dialog-close]="true" width="20px" heigth="20px">
      <img src="../../../../assets/icons/close-orange.svg" alt="close" width="20px" height="20px" />
    </mat-icon>
  </div>

  <form
    class="estado filter-container"
    [class.add-margin]="true"
    [formGroup]="form"
    *ngIf="form && !resumentResponse && !isLoading"
  >
    <div class="filter-container-group">
      <!--Fecha desde-->
      <mat-form-field appearance="outline" class="filter-container-form-field">
        <mat-label>Fecha</mat-label>
        <div (click)="matDateToggleTo.datepicker.open()">
          <input
            style="cursor: pointer !important"
            matInput
            [matDatepicker]="picker"
            formControlName="dateFrom"
            [placeholder]="'Fecha'"
            [max]="maxDate"
            [min]="minDate"
            readonly
          />
        </div>
        <mat-datepicker-toggle #matDateToggleTo matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <div class="time-container mb-6">
        <mat-form-field appearance="outline" class="time-form-field">
          <mat-label>Hora Desde</mat-label>
          <mat-select formControlName="hourFrom">
            <mat-option [value]="hour.value" *ngFor="let hour of availableHours">{{ hour.value }} hs</mat-option>
          </mat-select>
        </mat-form-field>
        <div class="px-2">:</div>
        <mat-form-field appearance="outline" class="time-form-field">
          <mat-label>Minutos</mat-label>
          <mat-select formControlName="minutesFrom">
            <mat-option [value]="minute.value" *ngFor="let minute of minutes">{{ minute.value }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="time-container">
        <mat-form-field appearance="outline" class="time-form-field">
          <mat-label>Hora hasta</mat-label>
          <mat-select formControlName="hourTo">
            <mat-option [value]="hour.value" *ngFor="let hour of availableHours">{{ hour.value }} hs</mat-option>
          </mat-select>
        </mat-form-field>
        <div class="px-2">:</div>
        <mat-form-field appearance="outline" class="time-form-field">
          <mat-label>Minutos</mat-label>
          <mat-select formControlName="minutesTo">
            <mat-option [value]="minute.value" *ngFor="let minute of minutes">{{ minute.value }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <mat-radio-group class="radio-group" *ngIf="terminalId" formControlName="terminal">
      <mat-radio-button class="radio-button" [value]="'1'"> Sólo ésta terminal </mat-radio-button>
      <mat-radio-button class="radio-button" [value]="'2'"> Todas las terminales </mat-radio-button>
    </mat-radio-group>

    <mat-error *ngIf="form.errors?.dateRangeError" class="error-dates">
      Debes seleccionar en un rango de fechas de 7 días o menos y la hora hasta no puede ser menor a la hora desde.
    </mat-error>

    <button
      *ngIf="form && !resumentResponse"
      class="generar-resumen-button"
      mat-stroked-button
      color="primary"
      (click)="generarResumen()"
      [disabled]="form.invalid"
    >
      Generar resumen
    </button>
  </form>

  <div *ngIf="isLoading" class="spinner-container">
    <mat-spinner style="margin: auto"></mat-spinner>
  </div>
  <div class="resumen-generado" id="resumenGenerado" *ngIf="resumentResponse">
    <div style="width: 100%; display: flex" *ngIf="resumen?.totalMovimientos > 0 || resumen?.totalMovimientosPix > 0">
      <img
        style="margin: auto"
        src="../../../../../assets/icons/fiserv-logo-orange.svg"
        alt="fiserv icon"
        width="50px"
        height="38px"
      />
    </div>
    <div *ngIf="resumen.totalMovimientosPix > 0" class="response-resumen-container">
      <span class="fecha-container">
        <strong>{{ getCurrentDate() }}</strong>
        <strong>{{ getCurrentTimeForPdf() }} Hs</strong>
      </span>
      <span class="border-top">Período solicitado:</span>
      <span
        >Desde: <strong> {{ resumen?.desde }} </strong></span
      >
      <span
        >Hasta: <strong> {{ resumen?.hasta }} </strong></span
      >
      <span class="border-top"
        >Número de operaciones PIX: <strong>{{ resumen?.totalMovimientosPix }}</strong>
      </span>
      <span class="border-top"
        >Total recaudado: <strong> {{ resumen?.totalRecaudado }}</strong>
      </span>
      <span class="border-top" *ngIf="terminalId">
        Nro Terminal: <strong>{{ resumen?.terminalId }}</strong>
      </span>
      <span *ngIf="terminalId">
        Terminales:
        <strong>{{ resumen?.allTerminals ? 'Todas las terminales' : 'Sólo esta terminal' }}</strong>
      </span>
      <span class="border-top textShort"
        >Usuario: <strong> {{ resumen?.user }} </strong></span
      >
    </div>
    <div *ngIf="resumen.totalMovimientosPix < 1 || !resumen.totalMovimientosPix">
      <div style="width: 100%; display: flex; margin: 1rem 0">
        <img
          style="margin: auto"
          src="../../../../../assets/icons/atention-icon-red.svg"
          alt="atention-icon"
          width="60px"
          height="60px"
        />
      </div>
      <p class="text-message">No existen movimientos en ese rango de fechas.</p>
    </div>
    <button
      *ngIf="resumen.totalMovimientosPix > 0"
      mat-button
      class="imprimir-resumen-button"
      color="primary"
      (click)="imprimirDescargarResumen()"
      [disabled]="form.invalid || printing"
    >
      <ng-container *ngIf="!printing; else loadingTemplate">
        {{ buttonLabel }}
      </ng-container>
      <ng-template #loadingTemplate>
        <mat-spinner diameter="14"></mat-spinner>
      </ng-template>
    </button>
    <button
      class="back-resumen-button"
      mat-stroked-button
      color="primary"
      (click)="backToForm()"
      [disabled]="form.invalid || printing"
    >
      Volver
    </button>
  </div>

  <div #pdfContent class="pdfContent" id="qr-to-download" *ngIf="resumen?.totalMovimientosPix > 0 && !terminalId">
    <div class="response-resumen-container-pdf">
      <div style="width: 100%; display: flex">
        <img
          style="margin: auto"
          src="../../../../../assets/icons/fiserv-logo-orange.svg"
          alt="fiserv icon"
          width="50px"
          height="38px"
        />
      </div>
      <h2>Resumen de operaciones</h2>
      <div class="response-resumen-container">
        <span class="fecha-container">
          <strong>{{ getCurrentDate() }}</strong>
          <strong>{{ getCurrentTimeForPdf() }} Hs</strong>
        </span>
        <span class="border-top">Período solicitado:</span>
        <span
          >Desde: <strong> {{ resumen?.desde }} </strong></span
        >
        <span
          >Hasta: <strong> {{ resumen?.hasta }} </strong></span
        >
        <span class="border-top"
          >Número de operaciones PIX: <strong>{{ resumen?.totalMovimientosPix }}</strong>
        </span>
        <span class="border-top"
          >Total recaudado: <strong> {{ resumen?.totalRecaudado }}</strong>
        </span>
        <span class="border-top" *ngIf="terminalId">
          Nro Terminal: <strong>{{ resumen?.terminalId }}</strong>
        </span>
        <span *ngIf="terminalId">
          Terminales:
          <strong>{{ resumen?.allTerminals ? 'Todas las terminales' : 'Sólo esta terminal' }}</strong>
        </span>
        <span class="border-top"
          >Usuario: <strong> {{ resumen?.user }} </strong></span
        >
      </div>
    </div>
  </div>
</div>
